import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'

import Chip from '@/components/Chip'

type MaskingEntity = {
  internallayer_advice: any
  brand: any
}

const MaskingRecipe = ({ internallayer_advice, brand }: MaskingEntity) => {
  const theme = useTheme()
  return (
    <Paper
      elevation={6}
      sx={{
        background:
          'linear-gradient(133.84deg, #4e4e4e -16.04%, #333333 9.33%, #1a1a1a 32.02%, #1a1a1a 62.06%, #262626 87.42%, #4e4e4e 112.12%)',
        borderRadius: '16px',
        padding: 3,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1} mb={3}>
        <Typography variant="h5">Masking:</Typography>
        <Chip
          label={brand}
          sx={{
            bgcolor: theme.palette.background.chip,
            color: theme.palette.common.black,
            '&:hover': {
              bgcolor: theme.palette.background.chip,
            },
          }}
        />
      </Stack>

      <TableContainer>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">
                <strong>Cervical</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Middle</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Incisal</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              { label: 'Instructions', key: 'instructions' },
              { label: 'Ceramic Type', key: 'ceramictype' },
              { label: 'Thickness', key: 'thickness' },
              { label: 'Staining Instructions', key: 'staining_instructions' },
            ].map((row) => (
              <TableRow key={row.key}>
                <TableCell>
                  <strong>{row.label}</strong>
                </TableCell>
                {['cervical', 'middle', 'incisal'].map((position) => (
                  <TableCell key={position} align="center">
                    {internallayer_advice[`${row.key}_${position}`] || '-'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default MaskingRecipe
